var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-card",class:{ 'pa-2 ma-2': !_vm.nopad, 'a-card-hover': _vm.hover }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }